import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import vuetify from "./plugins/vuetify";
import "material-design-icons-iconfont/dist/material-design-icons.css";
Vue.config.productionTip = false;
const NewDevice = { template: '<p>New!</p>' };

const routes = [
  { path: '/new', component: NewDevice },
  
];

const router = new VueRouter({ routes });

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount("#app");
